import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { RouterService } from "@app/root-store/router.service";

@Component({
    selector: "app-auth-button",
    templateUrl: "./auth-button.component.html",
    styleUrls: ["./auth-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthButtonComponent {
    @Input() provider = "";
    @Input() params: { firstName: string; lastName: string; email: string };
    @Input() authtype: "login" | "signup";
    @Input() iconPath: string;

    constructor(private readonly routerService: RouterService, private readonly authUserService: AuthUserService) {}

    get buttonText() {
        if (this.authtype === "login") {
            return "Continue with " + this.provider.charAt(0).toUpperCase() + this.provider.substring(1);
        }

        return "Sign up with " + this.provider.charAt(0).toUpperCase() + this.provider.substring(1);
    }

    auth() {
        this.authUserService.clearLoginErrorState();
        switch (this.provider) {
            case "email":
                this.authUserService.dispatchClearErrorPendingTrue();
                this.routerService.navigateToUrl([`/${this.authtype}/email`], { queryParamsHandling: "merge" }, this.params);
                break;

            case "google":
            case "apple":
                this.routerService.navigateToUrl([`/login/social/${this.provider}`], { queryParamsHandling: "merge" });
                break;
        }
    }
}
